import { render } from "./CardSettings.vue?vue&type=template&id=0bc8eede"
const script = {}
script.render = render

export default script